import { createBrowserHistory } from "history";
import { withUserType } from './userTypeParam';
let history;

if (process.env.IS_SERVER) {

} else {

    if (process.env.REACT_APP_PUBLIC_URL) {
        history = createBrowserHistory({ basename: process.env.REACT_APP_PUBLIC_URL });
    } else {
        history = createBrowserHistory();
    }

    // Carry `?usertype=direct|crm|pp` on every in-app navigation after the
    // landing page (see lib/userTypeParam.js). This is THE choke point: every
    // `history.push/replace` in src imports this singleton, `useHistory()` hands
    // back this same instance (it is what <ConnectedRouter history={history}>
    // receives), and connected-react-router's routerMiddleware(history) drives
    // it too — so wrapping here covers all ~430 call sites without editing them.
    // history v4 returns a plain object, so the methods are reassignable.
    const rawPush = history.push;
    const rawReplace = history.replace;
    history.push = (to, state) => rawPush(withUserType(to), state);
    history.replace = (to, state) => rawReplace(withUserType(to), state);

}

export default history;
